module.exports = __webpack_public_path__ + "static/img/冷凝水管.64f8e678.png";